import React, { Component } from 'react';
import Header from '../../header/header';
import TestForm from '../../TestForm';
import Aside from '../../aside';

class PageCreateTest extends Component {
  render() {
    return (
      <React.Fragment>
        <Header />
        <div className="admin-container">
          <TestForm testType={1} />
          <Aside />
        </div>
      </React.Fragment>
    );
  }
}

export default PageCreateTest;
